<template>
  <div class="wrapper">
    <CCHeader></CCHeader>
    <div class="data-wrapper">
      <div class="main">
        <div class="report">
          <div class="message">
            Account Login
          </div>
          <form @submit.prevent="authenticate()">
            <div class="auth-form-data">
              <div>
                <label style="margin-right: 20px;">Email:</label>
                <input v-model="auth.login" type="email">
              </div>
              <div>
                <label>Password</label>
                <input v-model="auth.password" type="password">
              </div>
            </div>
            <div>
              <button type="submit">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Loading :active="isLoading" :can-cancel="false"></Loading>
  </div>
</template>

<script>

  import Vue from 'vue';
  import CCHeader from '@/components/common/CCHeader';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';
  import VueLocalStorage from 'vue-ls';

  Vue.use(VueLocalStorage, {
    namespace: 'clickscontrol_'
  });

  export default {
    name: "auth-login",
    components: {
      CCHeader,
      Loading
    },
    data(){
      return {
        auth: {
          login: null,
          password: null
        },
        user: {

        },
        isLoading: false
      }
    },
    methods: {
      authenticate(){
        let that = this;
        let credentials = this.auth;
        let params = this.$route.query;

        this.isLoading = true;

        let loginStatus = null;
        loginStatus = this.$store.dispatch('login', credentials, {root: true});

        loginStatus.then(function(data) {
          if (data !== undefined && data !== false)
          {
            that.$store.dispatch('setAuthorizationStatus', true);
            that.$store.dispatch('setUserData', data);
            that.$ls.remove('userData');
            that.$ls.set('userData', data, 60 * 60 * 1000 * 24);

            if (params.redirect !== undefined) {

              that.isLoading = false;

              that.$router.push(params.redirect);
            }
          }
          else
          {
            that.$notification.setPosition('topRight')
              .setCloseStatus(true)
              .setCloseOnClick(true)
              .setCloseOnEscape(true)
              .setTimeout(false)
              .setSettings();

            that.$notification.showWarning('Warning!', 'Incorrect credentials! Please try again.');
          }

          that.isLoading = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: grid;
    grid-template-areas:
            "header"
            "content"
            "footer";
    width: 100%;
    overflow-x: hidden;
  }

  .data-wrapper {
    display: flex;
  }

  .main {
    display: grid;
    grid-template-columns: auto;
    width: 100vw;
  }

  .report {
    background-color: #f0f0f0;
    max-width: 100%;
    height: 100vh;
    width: 100vw;
    position: relative;

    & > .message {
      font-size: 24px;
      margin-top: 15px;
      margin-bottom: 25px;
    }

    & > form {
      background-color: #f0f0f0;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;

      & > .auth-form-data {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: center;

        & > div {
          margin-top: 10px;
          margin-bottom: 10px;

          & > input {
            margin-left: 30px;
          }
        }
      }

      & > div {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    &.sidebar-active {
      padding-left: 125px;
    }
  }

  .clear {
    clear: both;
  }

  @include mobile-only {
    .wrapper {
      display: grid;
      grid-template-areas:
              "header"
              "content"
              "footer";
    }
    grid-template-columns: 100vw;

    .main {
      grid-template-columns: 1fr;
    }

    .report {
      padding: 0;
      background-color: #fff;
      width: 100vw;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/AuthLogin.vue